<div class="container" [ngClass]="mainSpace()">
    <app-individuals *ngIf="isLoggedIn && selectedUserType ==='Individuals'"></app-individuals>
    <app-institutions *ngIf="isLoggedIn && selectedUserType === 'Institutions'"></app-institutions>
</div>
